
import { mapState, mapGetters, mapActions } from 'vuex';

export default {
  name: 'AppNotificationEventListener',

  computed: {
    ...mapState('user', ['user']),
    ...mapGetters('user', ['currentAccountUuid', 'currentLoginUuid']),
  },

  mounted() {
    this.listenForNotifications(this.currentLoginUuid);
  },

  beforeDestroy() {
    try {
      this.$echo.leave('login.' + this.currentLoginUuid);
    } catch (error) {
      // Silently handle errors when connection is already closing/closed
      // This prevents "Force close delete origin" errors from being reported
    }
  },

  methods: {
    ...mapActions('notification', ['refreshNotifications']),

    listenForNotifications(uuid) {
      this.$echo
        .private('login.' + uuid)
        .listen('AppNotification')
        .notification((notification) => {
          this.$nuxt.$emit('NewAppNotification', notification);
          // push notification to vuex
          this.refreshNotifications();
          // trigger notification popup
        });
    },
  },
};
